<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { DropdownBody, DropdownItem } from 'next/dropdown-menu/base';
import { KEYBOARD_SHORTCUT_PLATFORMS } from 'dashboard/components/widgets/modal/keyboardShortcutPlatforms';

const emit = defineEmits(['select']);
const { t } = useI18n();
const isOpen = ref(false);

const platforms = computed(() => [
  {
    value: KEYBOARD_SHORTCUT_PLATFORMS.WINDOWS_LINUX,
    label: t('KEYBOARD_SHORTCUTS.PLATFORMS.WINDOWS_LINUX.LABEL'),
    icon: 'i-lucide-monitor',
  },
  {
    value: KEYBOARD_SHORTCUT_PLATFORMS.MAC,
    label: t('KEYBOARD_SHORTCUTS.PLATFORMS.MAC.LABEL'),
    icon: 'i-lucide-laptop',
  },
]);

const openSubmenu = () => {
  isOpen.value = true;
};

const closeSubmenu = () => {
  isOpen.value = false;
};

const selectPlatform = platform => {
  closeSubmenu();
  emit('select', platform);
};
</script>

<template>
  <DropdownItem preserve-open class="!p-0 relative">
    <button
      type="button"
      class="flex gap-3 items-center p-2 w-full text-left rounded-lg reset-base text-sm text-n-slate-12 hover:bg-n-alpha-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand"
      aria-haspopup="menu"
      :aria-expanded="isOpen"
      @mouseenter="openSubmenu"
      @focus="openSubmenu"
      @click.stop="openSubmenu"
      @keydown.esc.stop="closeSubmenu"
    >
      <Icon
        class="flex-shrink-0 size-4 text-n-slate-11"
        icon="i-lucide-keyboard"
      />
      <span class="flex-grow">
        {{ t('SIDEBAR_ITEMS.KEYBOARD_SHORTCUTS') }}
      </span>
      <Icon
        class="flex-shrink-0 size-4 text-n-slate-11"
        icon="i-lucide-chevron-right"
      />
    </button>

    <DropdownBody
      v-if="isOpen"
      class="bottom-0 z-50 min-w-48 ltr:left-full rtl:right-full"
      role="menu"
      strong
    >
      <DropdownItem
        v-for="platform in platforms"
        :key="platform.value"
        :label="platform.label"
        :icon="platform.icon"
        :click="() => selectPlatform(platform.value)"
        role="menuitem"
        class="cursor-pointer whitespace-nowrap"
      />
    </DropdownBody>
  </DropdownItem>
</template>
